import React, {useMemo, forwardRef, useState, Fragment} from 'react';
import cn from 'classnames';
// import Tooltip from '../../../common/components/Tooltip';
import MBRModal from "../../../common/components/MBRModal";
import {MULTI_ROOM_DISCOUNT} from "./BriefConstants";

// const QUANTITY = Array.from(Array(11).keys());
// const tooltip = `By booking any additional rooms in now you can benefit
//   from having the same designer create a cohesive look throughout your home.
//   You'll also save money with our multi room offer: receive £40 off each additional
//   room from 3 or more, when booking a Complete Design Experience package.`;
const stopPropagation = e => {
  e.preventDefault();
  e.stopPropagation();
};

const BriefRoom = ({ room, value, proPlatform = false, onChange, openModal }) => {
  const { quantity, selected } = useMemo(
    () => {
      const selectedRoom = value.find(v => v.type === room.value);
      const roomQuantity = (selectedRoom && selectedRoom.quantity) || 0;
      return {
        quantity: roomQuantity,
        selected: roomQuantity > 0,
      };
    },
    [value, room],
  );
  const openModalInner = (modalText) => {
    openModal(modalText);
    // console.log(modalText);
  };

  // console.log(room);

  return (
    <Fragment>
      {room.chapterTitle && (
        <div className={cn('plate-select-grid_item', '-chapter-title')} key={`label_${room.chapterTitle}`}>
          {room.chapterTitle}
        </div>
      )}
      <div className={cn('plate-select-grid_item', { '-half-width': room.halfWidth })} key={`label_${room.value}`}>
        <div className={cn('plate-select', {'-quantity': quantity > 0 })}>
          {room.bestSeller && (
            <div className='best-seller-badge'>Popular</div>
          )}
          <input
            key={`input_${room.value}`}
            readOnly
            className="plate-select_input"
            type="radio"
            value={room.value}
            id={`room_type_${room.value}`}
            checked={selected}
          />
          <label
            htmlFor={`room_type_${room.value}`}
            className={cn('plate-select_label', { '-quantity': quantity > 0 })}
            onClick={() => {
              onChange({ type: room.value, quantity: selected ? 0 : 1 });
            }}
          >
            <div className="plate-select_icons-wrapper">
              <div className="plate-select_icons">
                {room.icon.map(icon => (
                  <svg className={`plate-select_icon -${icon}`} key={icon}>
                    <use xlinkHref={`${window.roomIconsSprite || ''}#icon_room-${icon}`} xmlnsXlink="http://www.w3.org/1999/xlink" />
                  </svg>
                ))}
              </div>
            </div>
            <div className="plate-select_title">
              {room.label}
            </div>
            {!proPlatform && (
              <div className="plate-select_text">
                {room.price}
              </div>
            )}
          </label>
          {room.tooltip && !proPlatform && (
            <button type="button" className="plate-select_info" onClick={() => openModalInner(room.tooltip)}>
              More info
            </button>
          )}
          {quantity > 0 && (
            <div className="plate-select_quantity" onClick={stopPropagation}>
              <button
                type="button"
                className={cn("plate-select_quantity-button -minus")}
                onClick={e => {
                  stopPropagation(e);
                  onChange({ type: room.value, quantity: quantity - 1 });
                }}
              >
                -
              </button>
              <div className="plate-select_quantity-text">{quantity}</div>
              <button
                type="button"
                className={"plate-select_quantity-button -plus"}
                onClick={e => {
                  stopPropagation(e);
                  onChange({ type: room.value, quantity: (quantity >= 9 ? 9 : 1 + quantity) });
                }}
              >
                +
              </button>
            </div>
          )}
        </div>
      </div>
    </Fragment>
  );
};

const BriefRooms = (
  { value, options, invalid, className, onChange, proPlatform, children },
  ref,
) => {
  const [contentModal, setContentModal] = useState('');
  const closeModal = () => {
    setContentModal('');
  };
  const openModal = (modalText) => {
    setContentModal(modalText);
  };

  const discountedRooms = () => {
    let roomsCount = 0;
    (value || []).forEach(room => roomsCount += room.type === 'room_styling' ? 0 : room.quantity);
    return roomsCount > 1 ? roomsCount - 1 : 0;
  };

  const savings = () => discountedRooms() * MULTI_ROOM_DISCOUNT;

  return (
    <div ref={ref} className={cn('brief_step -rooms', className)}>
      <div className="brief_step-title-wrapper -margin-bottom--10">
        <h2 className="brief_step-title">
          {"Choose your design services"}
        </h2>
        {discountedRooms() > 0 && (
          <div className="brief_step-note -note-red -margin-top-10">You've saved: £{savings()}!</div>
        )}
        <div className="brief_step-note">
          <span><b>Save £{MULTI_ROOM_DISCOUNT}</b> on each additional <b>Room Design Package</b> booked!</span>
        </div>
        {/*<div className="brief_step-info-hint -margin-top-10">Does not include Room Styling or Design Fix Packages.</div>*/}
      </div>

      <div className="brief_rooms-grid">
        <div className="plate-select-grid">
          {options.map(room => (
            <BriefRoom
              key={`fragment_${room.value}`}
              value={value}
              room={room}
              proPlatform={proPlatform}
              onChange={onChange}
              openModal={openModal}
            />
          ))}
        </div>
      </div>

      <MBRModal
        className="-brief"
        visible={contentModal !== ''}
        onRequestClose={closeModal}
        shouldCloseOnOverlayClick={true}
        buttonClose={true}
      >
        <div dangerouslySetInnerHTML={{ __html: contentModal }} />
        {/*{contentModal}*/}
      </MBRModal>

    </div>
)};

export default forwardRef(BriefRooms);



// WEBPACK FOOTER //
// ./app/javascript/components/brief/components/BriefRooms.js